<template>
  <div class="base64-tool">
    <h1>Base64 编解码工具</h1>
    
    <div class="converter-container">
      <!-- 文本输入区域 -->
      <div class="section">
        <h3>原始文本</h3>
        <el-input
          v-model="inputText"
          type="textarea"
          :rows="8"
          placeholder="请输入要编码/解码的文本"
        />
      </div>

      <!-- 操作按钮 -->
      <div class="button-group">
        <el-button type="primary" @click="encode">编码</el-button>
        <el-button type="success" @click="decode">解码</el-button>
        <el-button @click="copyResult">复制结果</el-button>
        <el-button @click="clearAll">清空</el-button>
      </div>

      <!-- 结果输出区域 -->
      <div class="section">
        <h3>转换结果</h3>
        <el-input
          v-model="outputText"
          type="textarea"
          :rows="8"
          readonly
          placeholder="转换结果将显示在这里"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage } from 'element-plus'

const inputText = ref('')
const outputText = ref('')

// Base64 编码
const encode = () => {
  if (!inputText.value) {
    ElMessage.warning('请输入要编码的文本')
    return
  }
  try {
    outputText.value = btoa(encodeURIComponent(inputText.value))
    ElMessage.success('编码成功')
  } catch (error) {
    ElMessage.error('编码失败：' + error.message)
  }
}

// Base64 解码
const decode = () => {
  if (!inputText.value) {
    ElMessage.warning('请输入要解码的文本')
    return
  }
  try {
    outputText.value = decodeURIComponent(atob(inputText.value.trim()))
    ElMessage.success('解码成功')
  } catch (error) {
    ElMessage.error('解码失败：无效的 Base64 编码')
  }
}

// 复制结果
const copyResult = async () => {
  if (!outputText.value) {
    ElMessage.warning('没有可复制的内容')
    return
  }
  try {
    await navigator.clipboard.writeText(outputText.value)
    ElMessage.success('复制成功')
  } catch (error) {
    ElMessage.error('复制失败')
  }
}

// 清空所有内容
const clearAll = () => {
  inputText.value = ''
  outputText.value = ''
  ElMessage.success('已清空')
}
</script>

<style scoped>
.base64-tool {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 80px;
}

.converter-container {
  margin-top: 20px;
}

.section {
  margin: 20px 0;
}

.button-group {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
}

h3 {
  margin-bottom: 10px;
  color: #303133;
}

:deep(.el-textarea__inner) {
  font-family: monospace;
  font-size: 14px;
}
</style> 